import { api } from '../../../shared/api/client';

export const getLogs = (params = {}) => api.post('/log-webhook/getLogs', params);
export const adminGetLogs = (params = {}) => api.post('admin/log-webhook/getLogs', params);
export const getTransactions = (params = {}) => api.post('transaction/getTransactions', params);
export const adminGetTransactions = (params = {}) => api.post('admin/transaction/getTransactions', params);
export const createTransferOutSide = (params = {}) => api.post('admin/withdraw-transaction/createTransferOutSide', params);
export const createWithdrawTransfer = (params = {}) => api.post('admin/withdraw-transaction/createWithdrawTransfer', params);
export const getBankReceives = () => api.get('admin/withdraw-transaction/getBankReceives');
export const getBankTransfers = () => api.get('admin/withdraw-transaction/getBankTransfers');
export const getWithdrawTransactions = (params = {}) => api.post('admin/withdraw-transaction/getWithdrawTransactions', params);
